import { useMutation } from '@tanstack/react-query';
import { api } from 'src/services/api';
import { Appointment } from 'src/models';
import { useAppointmentListClient } from './useGetAppointmentList';
import { useAppointmentDetailsClient } from './useGetAppointmentDetails';

export type UseMarkAppointmentAsProcessedPayload = {
  appointment_id: Appointment['appointment_id'];
  appt_uuid: Appointment['appt_uuid'];
};

export const useMarkAppointmentAsProcessed = () => {
  const { scanAppointment } = useAppointmentListClient();
  const { scanAppointment: scanAppointmentDetails } =
    useAppointmentDetailsClient();

  return useMutation({
    mutationKey: ['markAppointmentAsProcessed'],
    mutationFn: ({ appointment_id }: UseMarkAppointmentAsProcessedPayload) =>
      api
        .patch('/v2/mark_appointment_as_processed', { appointment_id })
        .then((res) => res.data),
    onSuccess: (_, { appt_uuid }) => {
      scanAppointment(appt_uuid, (a) => ({ ...a, is_processed: true }));
      scanAppointmentDetails(appt_uuid, (a) => ({ ...a, is_processed: true }));
    },
  });
};

export const useUnmarkAppointmentAsProcessed = () => {
  const { scanAppointment } = useAppointmentListClient();
  const { scanAppointment: scanAppointmentDetails } =
    useAppointmentDetailsClient();

  return useMutation({
    mutationKey: ['unmarkAppointmentAsProcessed'],
    mutationFn: ({ appointment_id }: UseMarkAppointmentAsProcessedPayload) =>
      api
        .patch('/v2/unmark_appointment_as_processed', { appointment_id })
        .then((res) => res.data),
    onSuccess: (_, { appt_uuid }) => {
      scanAppointment(appt_uuid, (a) => ({ ...a, is_processed: false }));
      scanAppointmentDetails(appt_uuid, (a) => ({ ...a, is_processed: false }));
    },
  });
};
